import { makeStyles } from "@fluentui/react-components";

export const WorkspaceOptionsListStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    width: "100%",
    maxHeight: "80vh",
  },
  option: {
    width: "100%",
    padding: "4px",
    boxSizing: "border-box",
  },
});
